export default __webpack_public_path__ + "static/media/mila-the-vegan-logo.431a50b0.png";